import React from 'react';

const RequestsTab = ({
  availabilityRequests,
  loading,
  handleApproveRequest,
  openRejectModal
}) => {
  const parseHour = (timeStr) => {
    if (!timeStr) return null;
    const parts = timeStr.split(':');
    return parseInt(parts[0]);
  };

  const getDayHours = (dayData) => {
    if (!dayData?.available) return 0;
    const start = parseHour(dayData.start_time);
    const end = parseHour(dayData.end_time);
    if (start === null || end === null) return 0;
    return Math.max(0, end - start);
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return '-';
    const hour = parseHour(timeStr);
    if (hour === null) return timeStr;
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour === 0 ? 12 : (hour > 12 ? hour - 12 : hour);
    return `${displayHour} ${period}`;
  };

  const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  return (
    <div className="requests-view">
      <div className="requests-header">
        <h3>Pending Availability Requests</h3>
        <span className="results-count">{availabilityRequests.length} pending</span>
      </div>

      {availabilityRequests.length === 0 ? (
        <div className="empty-state">
          <p>No pending availability requests</p>
        </div>
      ) : (
        <div className="requests-list">
          {availabilityRequests.map(request => {
            // Handle both possible data structures from backend
            const weeklyData = request.requested_changes?.weekly ||
                               request.requested_changes ||
                               request.requested_availability?.weekly ||
                               {};
            const availableDays = dayOrder.filter(day => weeklyData[day]?.available);
            const totalHours = dayOrder.reduce((sum, day) => sum + getDayHours(weeklyData[day]), 0);

            return (
              <div key={request.request_id} className="request-detail-card">
                <div className="request-detail-header">
                  <div className="request-employee-info">
                    <h3>{request.employee_name}</h3>
                    <span className="request-meta">
                      Submitted {new Date(request.created_at).toLocaleDateString()}
                    </span>
                  </div>
                  <span className={`status-badge ${request.status}`}>{request.status}</span>
                </div>

                <div className="request-detail-body">
                  <div className="request-summary-row">
                    <div className="summary-stat">
                      <span className="stat-value">{weeklyData.min_hours_per_week || 0}-{weeklyData.max_hours_per_week || 40}</span>
                      <span className="stat-label">Preferred hrs/week</span>
                    </div>
                    <div className="summary-stat">
                      <span className="stat-value">{availableDays.length}</span>
                      <span className="stat-label">Days available</span>
                    </div>
                    <div className="summary-stat">
                      <span className="stat-value">{totalHours}</span>
                      <span className="stat-label">Total hrs offered</span>
                    </div>
                  </div>

                  {weeklyData.notes && (
                    <div className="request-notes">
                      <strong>Notes:</strong> {weeklyData.notes}
                    </div>
                  )}

                  <div className="availability-detail-grid">
                    <div className="availability-detail-header">
                      <span>Day</span>
                      <span>Status</span>
                      <span>Hours</span>
                      <span>Duration</span>
                    </div>
                    {dayOrder.map(day => {
                      const dayData = weeklyData[day];
                      const isAvailable = dayData?.available;
                      const hours = getDayHours(dayData);

                      return (
                        <div key={day} className={`availability-detail-row ${isAvailable ? 'available' : 'unavailable'}`}>
                          <span className="day-name">{day.charAt(0).toUpperCase() + day.slice(1)}</span>
                          <span className={`availability-status ${isAvailable ? 'available' : 'unavailable'}`}>
                            {isAvailable ? 'Available' : 'Unavailable'}
                          </span>
                          <span className="time-range">
                            {isAvailable ? `${formatTime(dayData.start_time)} - ${formatTime(dayData.end_time)}` : '-'}
                          </span>
                          <span className="day-hours">
                            {isAvailable ? `${hours} hrs` : '-'}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="request-detail-actions">
                  <button
                    className="btn btn-success"
                    onClick={() => handleApproveRequest(request)}
                    disabled={loading}
                  >
                    Approve
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => openRejectModal(request)}
                    disabled={loading}
                  >
                    Reject
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RequestsTab;
